import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { UserService } from '../../services/user.service';
import { getUserFromSnapshot } from '../../utils/user.util';
import { AdminActions } from '.';

@Injectable()
export class AdminEffects {
  constructor(private actions$: Actions, private userService: UserService) {}

  setStudent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AdminActions.setStudent),
      exhaustMap((action) =>
        this.userService.getUser(action.studentId).pipe(
          map((snapshot) =>
            AdminActions.setStudentSuccess({ student: getUserFromSnapshot(snapshot) })
          ),
          catchError((error) => of(AdminActions.setStudentFailure({ error })))
        )
      )
    );
  });
}
